export const resolveOptionId = (currentOptionId, optionList = [], optionName) => {
  const normalizedOptionList = Array.isArray(optionList) ? optionList : [];

  if (currentOptionId) {
    const currentOption = normalizedOptionList.find((option) => option && option.Id === currentOptionId);
    if (currentOption) {
      return currentOption.Id;
    }
  }

  const nameMatch = normalizedOptionList.find((option) => option && option.Name === optionName);
  if (nameMatch) {
    return nameMatch.Id;
  }

  const fallbackOption = normalizedOptionList[normalizedOptionList.length - 1];
  return fallbackOption && fallbackOption.Id ? fallbackOption.Id : currentOptionId || "";
};
